import styles from "./Login.module.scss";
import { FormProvider } from "react-hook-form";
import { useLoginPage } from "./hooks/useLoginPage";
import { ILoginFormModel } from "./models/loginFormModel";
import { nameof } from "ts-simple-nameof";
import { useAppContext } from "../../../AppContext";
import { DefaultInputField } from "../../../common/components/forms/inputs/InputField/DefaultInputField";
import { DefaultButton } from "../../../common/components/button/defaultButton/DefaultButton";
import { AppLink } from "../../../common/components/button/link/Link";
import { routePaths } from "../../../common/infrastructure/routes/routePaths";
import { SingleSectionPageLayout } from "../../../common/components/common/SingleSectionPageLayout";

export const Login = () => {
  const { form, onSave } = useLoginPage();
  const { isDesktopOrTablet } = useAppContext();

  const children = (
    <>
      <div className={styles.root_fields}>
        <DefaultInputField
          name={nameof<ILoginFormModel>((x) => x.email)}
          label="Имейл"
          placeholder="name@example.com"
          required
        />
        <DefaultInputField
          name={nameof<ILoginFormModel>((x) => x.password)}
          label="Парола"
          placeholder="******"
          type={"password"}
          required
        />
      </div>

      <div className={styles.root_buttons}>
        <DefaultButton
          label="Вход"
          type="submit"
          width={isDesktopOrTablet ? "400px" : "80%"}
        />
        <div className={styles.root_buttons_link}>
          <AppLink
            className={styles.root_buttons_link}
            label="Забравена парола?"
            to={routePaths.resetPassword}
          />
        </div>
      </div>
    </>
  );

  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(onSave)}>
        <SingleSectionPageLayout
          title={"Вход"}
          children={children}
          maxHeight={isDesktopOrTablet ? "55%" : "75%"}
        />
      </form>
    </FormProvider>
  );
};
